<template>
  <ol class="navbar-steps mr-auto">
    <li
      class="nav-item"
      :class="{active: isActive(1)}"
    >
      Kontrol tárgy
    </li>
    <li
      class="nav-item"
      :class="{active: isActive(2)}"
    >
      Teszt variációk
    </li>
    <li
      class="nav-item"
      :class="{active: isActive(3)}"
    >
      Élesítés
    </li>
  </ol>
</template>
<script>
export default {
  watch: {
  },
  methods: {
    isActive(step) {
      if(typeof this.$route.meta.step !== 'undefined') {
        return this.$route.meta.step === step
      } else {
        return false
      }
    }
  }
}
</script>